import type { ReactElement, ReactNode } from "react"
import { memo } from "react"
import { Helmet } from "react-helmet"
import ErrorBoundary from "~/components/ErrorBoundary"
import NotificationBar from "~/components/NotificationBar"
import CheckoutContext from "~/context/CheckoutContext"

type BaseProps = {
  children: ReactNode
  skipBasketContext?: boolean
}

function Checkout({
  children,
  skipBasketContext = false,
}: BaseProps): ReactElement<BaseProps> {
  return (
    <ErrorBoundary>
      <Helmet
        bodyAttributes={{
          className: "_is-checkout _is-onestore",
        }}
      />
      <CheckoutContext skipBasketContext={skipBasketContext}>
        <NotificationBar location="checkout" />

        {children}
      </CheckoutContext>
    </ErrorBoundary>
  )
}

export default memo(Checkout)
